import React from 'react';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import './App.css';

function App() {
    return (
        <div className="App">
            <Header />
            <main className="main-content">
                <Dashboard />
            </main>
        </div>
    );
}

export default App;